<app-drag-and-drop
  [dragAndDropClass]="dragAndDropClass"
  [dragAndDropProgressClass]="dragAndDropProgressClass"
  [header]=""
  [text]="dragAndDropText"
  [processingText]="processingText"
  (dropFiles)="save($event)"
></app-drag-and-drop>

<app-tab-grid
  i18n-name
  name="Documents"
  gridCssClass="store-documents-grid"
  [columnDefs]="columnDefs"
  [rowData]="storedDocuments"
  [showExport]="false"
  [showCreate]="false"
  (edit)="openDocument($event)"
  (delete)="removeDocument($event)"
></app-tab-grid>
